import { application_registration } from '@axo/shared/data-access/types';
import { application_registration_hooks } from '@axo/shared/data-access/hooks';

export const useLenderIsActiveWithSARR = (applicationID: string) => {
  const registrationStatus =
    application_registration_hooks.useRegistrationStatus(applicationID);

  const lenderIsActiveWithSARR = (lenderID: string) => {
    const lender = registrationStatus.data?.Items.find(
      (item) => item.LenderID === lenderID
    );
    return (
      lender?.Status ===
        application_registration.RegistrationStatus
          .RegistrationStatusAutoRegistration ||
      lender?.Status ===
        application_registration.RegistrationStatus
          .RegistrationStatusReRegistration
    );
  };

  return { lenderIsActiveWithSARR };
};
